import styled from 'styled-components';

import ActionButton from 'components/action-button';

export const ActionButtonStyled = styled(ActionButton)``;
